import ActiveRedis, { ConnectionType } from './ActiveRedis';
import RecordNotFound from 'lib/errors/RecordNotFound';

interface User {
  id: string,
  firstname: string,
  lastname: string,
  organizationIds?: string[],
}

class User extends ActiveRedis {

  static namespace = 'users';

  static async getOrganizationIds(userId:string):Promise<string[]> {
    const redis = this.redis();
    return await redis.lrange(`${this.namespace}:${userId}:organizations`, 0, -1);
  }

  static async find(userId: string):Promise<User> {
    const redis = this.redis();
    const user = await redis.hgetall(`${this.namespace}:${userId}`) as unknown as User;
    if(user) {
      return user;
    } else {
      //@ts-ignore
      throw new RecordNotFound(`User ${userId} not found.`);
    }
  }

  static async create(user:User) {
    const redis = this.redis();
    const pipeline = redis.pipeline();
    pipeline.hset(`${this.namespace}:${user.id}`, {
      firstname: user.firstname,
      lastname: user.lastname
    });

    user.organizationIds.map(async (organizationId) => {
       pipeline.lpush(`${this.namespace}:${user.id}:organizations`, organizationId);
    });
 
    const [data] = await pipeline.exec();

    return data;
  }

  constructor(_user:Partial<User>) {
    super();
    if(_user) Object.assign(this, _user);
  }

  displayName():string {
    if(this.firstname && this.lastname) {
      return `${this.firstname} ${this.lastname}`
    } else {
      return this.id;
    }
  }

  displayInitials():string {
    if(this.firstname && this.lastname) {
      return `${this.firstname?.charAt(0)?.toUpperCase()}${this.lastname?.charAt(0)?.toUpperCase()}`
    } else {
      return this.id?.charAt(0)?.toUpperCase();
    }    
  }

}

export default User;